import { github, medium, polygonscan, twitter } from '../assets';

const Footer = () => (
  <footer>
    <p>{new Date().getFullYear()} Decentralot (c)</p>
    <div className="social">
      <a target="_blank" rel="noreferrer" href="https://github.com/matoshisakamoto"><img alt="Github" src={github}/></a>
      <a target="_blank" rel="noreferrer" href="https://medium.com/@matoshisakamoto"><img alt="Medium" src={medium}/></a>
      <a target="_blank" rel="noreferrer" href="https://polygonscan.com/address/0x517381fc7e36ab33a1651bf8e1b09ef1eb5889fb#code"><img alt="Polygonscan" src={polygonscan}/></a>
      <a target="_blank" rel="noreferrer" href="https://twitter.com/matoshisama"><img alt="Twitter" src={twitter}/></a>
    </div>
  </footer>
);


export default Footer

